import { render, staticRenderFns } from "./inentPay.vue?vue&type=template&id=265c88fc&"
import script from "./inentPay.vue?vue&type=script&lang=js&"
export * from "./inentPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports